import comment from '@/api/comment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
	edit_data: {}
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_EDIT_DATA(state, data) {
		state.edit_data = data
	}
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				search: context.state.search
			},
			attrubutes
		)
		return comment.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},

	store(context, data) {
		return comment.store(data)
	},

	update(context, data) {
		return comment.update(data)
	},
	destroy(context, id) {
		return comment.destroy(id)
	},
	async find(context, id) {
		if (_.isEmpty(context.state.edit_data)) {
			let response = await comment.find(id)
			context.commit('SET_EDIT_DATA', response.data)
		}
	}
}
